var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.editMode
    ? _c(
        "div",
        {
          staticClass: "innerPadding30 margin30Top description",
          staticStyle: { "padding-bottom": "20px", border: "1px solid #000" }
        },
        [
          _c("div", { staticClass: "oldTableContainer width100 fontRoboto" }, [
            _vm._v(
              "\n            Erfasse hier deine Inhalte wie Beiträge, Fotos und Social Media-Posts\n            "
            ),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "textAlignRight buttonBlockContainerRight" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-white teaserButton",
                    on: { click: _vm.enterEditMode }
                  },
                  [_vm._v("Weiter")]
                )
              ]
            )
          ])
        ]
      )
    : _c(
        "div",
        {
          staticClass: "border-color1",
          staticStyle: { "margin-top": "30px", "padding-bottom": "20px" }
        },
        [
          _vm.tabSize == 5
            ? _c(
                "div",
                {
                  staticClass: "oldTabOuterContainer tabOuterContainer clearfix"
                },
                [
                  _c(
                    "div",
                    { staticClass: "oldTabContainerQuarter clearfix" },
                    [
                      _c(
                        "div",
                        {
                          class: [
                            { active: _vm.isActive(0) },
                            "tabEntry",
                            "oldTabQuarter"
                          ],
                          on: {
                            click: function($event) {
                              _vm.selectTab(0, $event)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(0)))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: [
                            { active: _vm.isActive(1) },
                            "tabEntry",
                            "oldTabQuarter"
                          ],
                          on: {
                            click: function($event) {
                              _vm.selectTab(1, $event)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(1)))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "oldTabContainerQuarter clearfix" },
                    [
                      _c(
                        "div",
                        {
                          class: [
                            { active: _vm.isActive(2) },
                            "tabEntry",
                            "oldTabQuarter"
                          ],
                          on: {
                            click: function($event) {
                              _vm.selectTab(2, $event)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(2)))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: [
                            { active: _vm.isActive(3) },
                            "tabEntry",
                            "oldTabQuarter"
                          ],
                          on: {
                            click: function($event) {
                              _vm.selectTab(3, $event)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(3)))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "oldTabContainerQuarter clearfix" },
                    [
                      _c(
                        "div",
                        {
                          class: [
                            { active: _vm.isActive(4) },
                            "tabEntry",
                            "oldTabQuarter"
                          ],
                          on: {
                            click: function($event) {
                              _vm.selectTab(4, $event)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(4)))])]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabSize == 4
            ? _c(
                "div",
                {
                  staticClass: "oldTabOuterContainer tabOuterContainer clearfix"
                },
                [
                  _c(
                    "div",
                    { staticClass: "oldTabContainerQuarter clearfix" },
                    [
                      _c(
                        "div",
                        {
                          class: [
                            { active: _vm.isActive(0) },
                            "tabEntry",
                            "oldTabQuarter"
                          ],
                          on: {
                            click: function($event) {
                              _vm.selectTab(0, $event)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(0)))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: [
                            { active: _vm.isActive(1) },
                            "tabEntry",
                            "oldTabQuarter"
                          ],
                          on: {
                            click: function($event) {
                              _vm.selectTab(1, $event)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(1)))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "oldTabContainerQuarter clearfix" },
                    [
                      _c(
                        "div",
                        {
                          class: [
                            { active: _vm.isActive(2) },
                            "tabEntry",
                            "oldTabQuarter"
                          ],
                          on: {
                            click: function($event) {
                              _vm.selectTab(2, $event)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(2)))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: [
                            { active: _vm.isActive(3) },
                            "tabEntry",
                            "oldTabQuarter"
                          ],
                          on: {
                            click: function($event) {
                              _vm.selectTab(3, $event)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(3)))])]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabSize == 3
            ? _c(
                "div",
                {
                  staticClass: "oldTabOuterContainer tabOuterContainer clearfix"
                },
                [
                  _c(
                    "div",
                    { staticClass: "oldTabContainerThird first clearfix" },
                    [
                      _c(
                        "div",
                        {
                          class: [
                            { active: _vm.isActive(0) },
                            "tabEntry",
                            "oldTabThird"
                          ],
                          on: {
                            click: function($event) {
                              _vm.selectTab(0, $event)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(0)))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: [
                            { active: _vm.isActive(1) },
                            "tabEntry",
                            "oldTabThird"
                          ],
                          on: {
                            click: function($event) {
                              _vm.selectTab(1, $event)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.getLabel(1)))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "oldTabContainerThird" }, [
                    _c(
                      "div",
                      {
                        class: [
                          { active: _vm.isActive(2) },
                          "tabEntry",
                          "oldTabThird"
                        ],
                        on: {
                          click: function($event) {
                            _vm.selectTab(2, $event)
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.getLabel(2)))])]
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabSize == 2
            ? _c(
                "div",
                {
                  staticClass: "oldTabOuterContainer tabOuterContainer clearfix"
                },
                [
                  _c("div", { staticClass: "oldTabContainerHalf clearfix" }, [
                    _c(
                      "div",
                      {
                        class: [
                          { active: _vm.isActive(0) },
                          "tabEntry",
                          "oldTabHalf"
                        ],
                        on: {
                          click: function($event) {
                            _vm.selectTab(0, $event)
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.getLabel(0)))])]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: [
                          { active: _vm.isActive(1) },
                          "tabEntry",
                          "oldTabHalf"
                        ],
                        on: {
                          click: function($event) {
                            _vm.selectTab(1, $event)
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.getLabel(1)))])]
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabSize == 1
            ? _c(
                "div",
                {
                  staticClass: "oldTabOuterContainer tabOuterContainer clearfix"
                },
                [
                  _c("div", { staticClass: "oldTabContainerSingle clearfix" }, [
                    _c(
                      "div",
                      {
                        class: [
                          { active: _vm.isActive(0) },
                          "tabEntry",
                          "oldTabSingle"
                        ],
                        on: {
                          click: function($event) {
                            _vm.selectTab(0, $event)
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.getLabel(0)))])]
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive("report")
            ? _c("userContentReport", {
                attrs: { project: _vm.project, contentkey: _vm.contentkey },
                on: { cancel: _vm.leaveEditMode }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive("embeds")
            ? _c("userContentEmbeds", {
                attrs: { project: _vm.project, contentkey: _vm.contentkey },
                on: { cancel: _vm.leaveEditMode }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive("links")
            ? _c("userContentLinks", {
                attrs: { project: _vm.project, contentkey: _vm.contentkey },
                on: { cancel: _vm.leaveEditMode }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive("images")
            ? _c("userContentImages", {
                attrs: { project: _vm.project, contentkey: _vm.contentkey },
                on: { cancel: _vm.leaveEditMode }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive("reply")
            ? _c("userContentReply", {
                attrs: {
                  project: _vm.project,
                  contentkey: _vm.contentkey,
                  replycontentkey: _vm.replycontentkey
                },
                on: { cancel: _vm.leaveEditMode }
              })
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6e5db2d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e5db2d4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserContentEditor.vue
// module id = 472
// module chunks = 2